import React from "react";
import { useNavigate } from "react-router-dom";
import "../components/ProfileSetup.css";
import { useLanguage } from "../i18n";

export default function AccountType() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handlePersonal = () => {
    navigate("/my-profile?type=personal");
  };

  const handleCorporate = () => {
    navigate("/my-profile?type=creator");
  };

  return (
    <div className="popup-overlay">
      <div className="popup-container">

        <button
          className="popup-close"
          onClick={() => navigate("/")}
          type="button"
        >
          ✕
        </button>

        <h2 className="popup-title">{t("chooseAccountType")}</h2>

        <p className="popup-subtitle">
          {t("accountTypeIntro")}
        </p>

        <button
          className="popup-btn"
          onClick={handlePersonal}
          type="button"
        >
          {t("personal")}
        </button>

        <button
          className="pseudo-btn"
          onClick={handleCorporate}
          type="button"
          style={{ width: "100%", marginTop: "12px" }}
        >
          {t("corporate")}
        </button>

      </div>
    </div>
  );
}
